import React from 'react';
import { object, bool } from 'prop-types';
import ExpandableEmbeddedMap from '@gumtree/ui-library/src/maps/expandable-embedded-map';

import { MapTabContainer } from './map-tab.style';

const MapTab = ({ baseConfig, mapDetails: { latitude, longitude }, isMobileCardsLayout }) => {
    return (
        <MapTabContainer
            className="map-container-scroll"
            isMobileCardsLayout={isMobileCardsLayout}
            data-testid="vip-map"
        >
            <ExpandableEmbeddedMap
                embeddedMapApiKey={process.env.VIP_EMBEDDED_MAP_API_KEY}
                dynamicMapApiKey={process.env.VIP_DYNAMIC_MAP_API_KEY}
                lat={latitude}
                long={longitude}
                refreshMap={false}
                width="100%"
                height={baseConfig?.device?.type === 'mobile' ? '250px' : '500px'}
            />
        </MapTabContainer>
    );
};

MapTab.defaultProps = {
    baseConfig: {},
    isMobileCardsLayout: false,
};

MapTab.propTypes = {
    baseConfig: object,
    isMobileCardsLayout: bool,
    mapDetails: object.isRequired,
};

export default MapTab;
